import { Component, Inject } from "@angular/core";
import { FormBuilder, Formio } from "formiojs";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { AppService } from "../app.service";
import { HttpClient } from "@angular/common/http";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Guid } from "guid-typescript";
import { FormioExport } from "formio-export";

@Component({
  selector: "app-east-coast",
  templateUrl: "./east-coast.component.html",
})
export class EastCoastApplication {
  // Formio.builder(document.getElementById('builder'), {}).then(function(form){
  //   form.webform.submission = {
  //       data: prefilledDataObject
  //   };
  // });

  formSpec: any;
  formData: any;
  formId = Guid.create().toJSON().value;
  router: Router;
  appService: AppService;
  httpClient: HttpClient;
  baseUrl: string;
  moment = moment;
  ngxLoader: NgxUiLoaderService;
  jsonDataUrl: string;
  Company_Name = "Resolution Institute";
  ABN_ACN = "69008651232";
  Address_Line_1 = "Suite 602, Level 6, Tower B, Zenith Centre";
  Address_Line_2 = "821-843 Pacific Highway";
  Suburb = "Chatswood";
  State = "NSW";
  Postcode = "2067";
  Telephone_number = "(02) 9251 3366";
  Fax_number = "(02) 9251 3733";
  Email = "nominations@resolution.institute";
  constructor(
    router: Router,
    appService: AppService,
    httpClient: HttpClient,
    ngxLoader: NgxUiLoaderService,
    @Inject("BASE_URL") baseUrl: string,
    private route: ActivatedRoute
  ) {
    this.router = router;
    this.appService = appService;
    this.httpClient = httpClient;
    this.baseUrl = baseUrl;
    this.ngxLoader = ngxLoader;
    this.route.queryParamMap.subscribe((params) => {
      this.jsonDataUrl = params.get("jsonUrl");
    });
  }

  ngOnInit() {
    // var that = this;
    var moment1 = require("moment-business-days");
    var todayMinus20 = moment1().businessAdd(-20)._d.toISOString();
    var todayMinus15 = moment1().businessAdd(-15)._d.toISOString();
    var todayMinus10 = moment1().businessAdd(-10)._d.toISOString();
    var todayPlus12Months = moment().add(12, "months").toISOString();
    var todayMinus12Months = moment().add(-12, "months").toISOString();
    var todayMinus3Months = moment().add(-3, "months").toString();
    var todayPlus6Months = moment().add(6, "months").toISOString();
    var todayMinus6Months = moment().add(-6, "months").toString();
    console.log("todayMinus20", todayMinus20);
    var formData;
    var httpClient = this.httpClient;
    var baseUrl = this.baseUrl;
    var that = this;
    var jsonDataUrl = this.jsonDataUrl;
    var formId = this.formId;

    var formComponents = [
      {
        html: "<p>This application form has been designed to step you through the Building and Construction Industry Security of Payments Acts through the various states.</p><p>Although this form references and links to relevant legislation, its purpose is merely descriptive and is not intended to constitute legal advice. This form must not be relied on as legal advice. It is a guide for information only and should be used in conjunction with the legislation. For more information about this topic, refer to the applicable legislation or seek independent legal advice.</p><p>For your convenience, please ensure that you have access to the following documentation before you begin filling in the form:</p><p>- Building contract (if possible, please have access to a separate PDF of any due date clauses in the contract)</p><p>- Payment claim</p><p>- Payment schedule (if provided)</p><p>- Notice of intention to apply for adjudication (if relevant)</p><p>- Project details</p><p>- Submissions</p><p>- Other relevant attachments and evidence</p><p>Upon completion of the online form, except for the ACT, please make sure you serve the respondent with a complete copy of the application in accordance with the relevant State Act that you are applying under.</p>",
        label: "Content",
        refreshOnChange: false,
        key: "content",
        type: "content",
        input: false,
        tableView: false,
      },
      {
        type: "radio",
        label: "(I have read this information and agree).",
        input: true,
        inline: true,
        tableView: false,
        key: "terms",
        persistent: true,
        values: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        validate: {
          // "required": true
        },
      },
      {
        type: "select",
        label: "Which state did the construction work take place in?",
        key: "applicantState",
        placeholder: "Select one",
        data: {
          values: [
            { value: "NSW", label: "NSW" },
            { value: "VIC", label: "VIC" },
            { value: "SA", label: "SA" },
            { value: "ACT", label: "ACT" },
            { value: "TAS", label: "TAS" },
            { value: "WA", label: "WA" },
          ],
        },
        dataSrc: "values",
        defaultValue: "",
        template: "<span>{{ item.label }}</span>",
        input: true,
        validate: {
          required: true,
        },
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "the relevant legislation is <a href='http://www8.austlii.edu.au/cgi-bin/viewdb/au/legis/nsw/consol_act/bacisopa1999606/' target='_blank'>'NSW Building and Construction Industry Security of Payments Act 1999'</a> and will be referred to from hereon as ‘the Act’",
        inputMask: "",
        key: "applicantNswText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        conditional: {
          json: {
            "===": [
              {
                var: "data.applicantState",
              },
              "NSW",
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "the relevant legislation is <a href='http://www8.austlii.edu.au/cgi-bin/viewdb/au/legis/vic/consol_act/bacisopa2002606/' target='_blank'>'VIC Building and Construction Industry Security of Payments Act 2002'</a> and will be referred to from hereon as ‘the Act’",
        inputMask: "",
        key: "applicantVicText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        conditional: {
          json: {
            "===": [
              {
                var: "data.applicantState",
              },
              "VIC",
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "the relevant legislation is for <a href='http://www8.austlii.edu.au/cgi-bin/viewdb/au/legis/tas/consol_act/bacisopa2009606/' target='_blank'>'TAS Building and Construction Industry Security of Payments Act 2009'</a> and will be referred to from hereon as ‘the Act’",
        inputMask: "",
        key: "applicantTasText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        conditional: {
          json: {
            "===": [
              {
                var: "data.applicantState",
              },
              "TAS",
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "the relevant legislation is for <a href='http://www8.austlii.edu.au/cgi-bin/viewdb/au/legis/sa/consol_act/bacisopa2009606/' target='_blank'>'SA Building and Construction Industry Security of Payments Act 2009'</a> and will be referred to from hereon as ‘the Act’",
        inputMask: "",
        key: "applicantSaText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        conditional: {
          json: {
            "===": [
              {
                var: "data.applicantState",
              },
              "SA",
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "the relevant legislation is for <a href='http://www8.austlii.edu.au/cgi-bin/viewdb/au/legis/act/consol_act/baciopa2009606/' target='_blank'>'ACT Building and Construction Industry Security of Payments Act 2009'</a> and will be referred to from hereon as ‘the Act’",
        inputMask: "",
        key: "applicantActText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        conditional: {
          json: {
            "===": [
              {
                var: "data.applicantState",
              },
              "ACT",
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "the relevant legislation is <a href='http://classic.austlii.edu.au/au/legis/wa/num_act/baciopa20214o2021652/' target='_blank'>'Building and Construction Industry (Security of Payment Act) 2021 (WA)'</a> and will be referred to from hereon as ‘the Act’",
        inputMask: "",
        key: "applicantNswText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        conditional: {
          json: {
            "===": [
              {
                var: "data.applicantState",
              },
              "WA",
            ],
          },
        },
      },
      {
        title: "Applicant details",
        collapsible: true,
        key: "panel",
        type: "panel",
        label: "Panel",
        input: false,
        tableView: false,
        components: [
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "Name of Applicant (Company)",
            key: "applicantName",
            placeholder: "",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "ABN/ACN",
            key: "applicantABN",
            placeholder: "",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
              pattern: "^[0-9]+$",
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "button",
            label: "Check",
            key: "check",
            disableOnInvalid: false,
            input: true,
            tableView: true,
            action: "custom",
            custom: "window.onCheck(data.applicantABN)",
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "ABN is valid",
            inputMask: "",
            key: "abnValidText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "abnSuccess",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.displayabnValidationSuccess",
                  },
                  true,
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "ABN is not valid",
            inputMask: "",
            key: "abnNotValidText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "abnFailure",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.displayabnValidationFailure",
                  },
                  true,
                ],
              },
            },
          },
          {
            type: "select",
            label: "Business Structure",
            key: "applicantBusinessStructure",
            placeholder: "Select one",
            data: {
              values: [
                {
                  value: "Commonwealth Government",
                  label: "Commonwealth Government",
                },
                {
                  value: "Incorporated Association",
                  label: "Incorporated Association",
                },
                { value: "Local Government", label: "Local Government" },
                { value: "Ltd Company", label: "Ltd Company" },
                { value: "Local Government", label: "Local Government" },
                { value: "Partnership", label: "Partnership" },
                { value: "Pty Ltd Company", label: "Pty Ltd Company" },
                { value: "Sole trader", label: "Sole trader" },
                { value: "State Government", label: "State Government" },
                { value: "Trust", label: "Trust" },
                { value: "Other", label: "Other" },
              ],
            },
            dataSrc: "values",
            validate: {
              required: true,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
            defaultValue: "",
            template: "<span>{{ item.label }}</span>",
            input: true,
          },
          // this is for nsw and all other states
          {
            type: "select",
            label: "Business Type/Activity",
            key: "applicantBusinessType",
            placeholder: "Select one",
            data: {
              values: [
                { value: "Principal", label: "Principal" },
                { value: "Head contractor", label: "Head contractor" },
                { value: "Subcontractor", label: "Subcontractor" },
                { value: "Supplier", label: "Supplier" },
                { value: "Consultant", label: "Consultant" },
                { value: "Not Specified", label: "Not Specified" },
              ],
            },
            dataSrc: "values",
            validate: {
              required: true,
            },
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.terms" }, "yes"] },
                  {
                    in: [
                      { var: "data.applicantState" },
                      ["NSW", "SA", "ACT", "TAS"],
                    ],
                  },
                ],
              },
            },
            defaultValue: "",
            template: "<span>{{ item.label }}</span>",
            input: true,
          },

          // this is for VIC - has special list
          {
            type: "select",
            label: "Business Type/Activity",
            key: "applicantBusinessType",
            placeholder: "Select one",
            data: {
              values: [
                { value: "Consultant", label: "Consultant" },
                { value: "Developer", label: "Developer" },
                { value: "Head contractor", label: "Head contractor" },
                { value: "Major subcontractor", label: "Major subcontractor" },
                {
                  value: "Manufacturer of building materials or components",
                  label: "Manufacturer of building materials or components",
                },
                { value: "Project manager", label: "Project manager" },
                { value: "Supplier", label: "Supplier" },
                { value: "Trade subcontractor", label: "Trade subcontractor" },
                { value: "Other", label: "Other" },
              ],
            },
            dataSrc: "values",
            validate: {
              required: true,
            },
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.terms" }, "yes"] },
                  { "===": [{ var: "data.applicantState" }, "VIC"] },
                ],
              },
            },
            defaultValue: "",
            template: "<span>{{ item.label }}</span>",
            input: true,
          },

          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Contact Person",
            inputMask: "",
            key: "applicantContactPersonText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "applicantContactPersonName",
            placeholder: "Name",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "applicantContactPersonPosition",
            placeholder: "Position",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Address",
            inputMask: "",
            key: "applicantAddressText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "applicantAddressNumberStreet",
            placeholder: "Number/Street",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "applicantSuburb",
            placeholder: "Suburb",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "applicantAddressState",
            placeholder: "State",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "applicantPostCode",
            placeholder: "Postcode",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            label: "Phone",
            inputMask: "(99) 9999-9999",
            tableView: true,
            persistent: true,
            validate: {
              required: false,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
            key: "applicantPhone",
            type: "textfield",
            input: true,
          },
          {
            label: "Fax",
            inputMask: "(99) 9999-9999",
            tableView: true,
            persistent: true,
            validate: {
              required: false,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
            key: "applicantFax",
            type: "textfield",
            input: true,
          },
          {
            label: "Email",
            tableView: true,
            validate: {
              required: true,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
            key: "applicantEmail",
            type: "email",
            input: true,
          },
          {
            type: "select",
            label: "Does the applicant retain advisors?",
            key: "retainAdvisers",
            placeholder: "Select one",
            data: {
              values: [
                { value: "claimPreparer", label: "Claim preparer" },
                { value: "consultant", label: "Consultant" },
                { value: "solicitors", label: "Solicitors" },
                { value: "none", label: "None" },
                { value: "notKnown", label: "Not known" },
              ],
            },
            dataSrc: "values",
            defaultValue: "",
            template: "<span>{{ item.label }}</span>",
            input: true,
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          //start for retain advisors
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Contact Person",
            inputMask: "",
            key: "retailAdvisorContactPersonText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            conditional: {
              json: {
                in: [
                  {
                    var: "data.retainAdvisers",
                  },
                  ["claimPreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "retailAdvisorContactPersonName",
            placeholder: "Name",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.retainAdvisers",
                  },
                  ["claimPreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "retailAdvisorContactPersonPosition",
            placeholder: "Position",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.retainAdvisers",
                  },
                  ["claimPreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Address",
            inputMask: "",
            key: "retailAdvisorAddressText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            conditional: {
              json: {
                in: [
                  {
                    var: "data.retainAdvisers",
                  },
                  ["claimPreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "retailAdvisorAddressNumberStreet",
            placeholder: "Number/Street",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.retainAdvisers",
                  },
                  ["claimPreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "retailAdvisorSuburb",
            placeholder: "Suburb",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.retainAdvisers",
                  },
                  ["claimPreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "retailAdvisorState",
            placeholder: "State",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.retainAdvisers",
                  },
                  ["claimPreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "retailAdvisorPostCode",
            placeholder: "Postcode",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.retainAdvisers",
                  },
                  ["claimPreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            label: "Phone",
            inputMask: "(99) 9999-9999",
            tableView: true,
            persistent: true,
            validate: {
              required: false,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.retainAdvisers",
                  },
                  ["claimPreparer", "consultant", "solicitors"],
                ],
              },
            },
            key: "retailAdvisorPhone",
            type: "textfield",
            input: true,
          },
          {
            label: "Fax",
            inputMask: "(99) 9999-9999",
            tableView: true,
            persistent: true,
            validate: {
              required: false,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.retainAdvisers",
                  },
                  ["claimPreparer", "consultant", "solicitors"],
                ],
              },
            },
            key: "retailAdvisorFax",
            type: "textfield",
            input: true,
          },
          {
            label: "Email",
            tableView: true,
            validate: {
              required: true,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.retainAdvisers",
                  },
                  ["claimPreparer", "consultant", "solicitors"],
                ],
              },
            },
            key: "retailAdvisorEmail",
            type: "email",
            input: true,
          },
        ],
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },

      //end for retain advisors

      // start all fields from beginning for respondant
      {
        title: "Respondent details",
        collapsible: true,
        key: "panel",
        type: "panel",
        label: "Panel",
        input: false,
        tableView: false,
        components: [
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "Company (Respondent)",
            key: "respondentName",
            placeholder: "",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "ABN/ACN",
            key: "respondentABN",
            placeholder: "",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "button",
            label: "Check",
            key: "checkRespondentBN",
            disableOnInvalid: false,
            input: true,
            tableView: true,
            action: "custom",
            custom: "window.onCheck1(data.respondentABN)",
            // disabled: "window.checkValid(data.applicantABN)",
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "ABN is valid",
            inputMask: "",
            key: "abnValidTextRespondent",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "abnSuccess",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.displayabnValidationSuccessRespondent",
                  },
                  true,
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "ABN is not valid",
            inputMask: "",
            key: "abnNotValidTextRespondent",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "abnFailure",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.displayabnValidationFailureRespondent",
                  },
                  true,
                ],
              },
            },
          },

          {
            type: "select",
            label: "Business Structure",
            key: "respondentBusinessStructure",
            placeholder: "Select one",
            data: {
              values: [
                {
                  value: "Commonwealth Government",
                  label: "Commonwealth Government",
                },
                {
                  value: "Incorporated Association",
                  label: "Incorporated Association",
                },
                { value: "Local Government", label: "Local Government" },
                { value: "Ltd Company", label: "Ltd Company" },
                { value: "Local Government", label: "Local Government" },
                { value: "Partnership", label: "Partnership" },
                { value: "Pty Ltd Company", label: "Pty Ltd Company" },
                { value: "Sole trader", label: "Sole trader" },
                { value: "State Government", label: "State Government" },
                { value: "Trust", label: "Trust" },
                { value: "Other", label: "Other" },
              ],
            },
            dataSrc: "values",
            validate: {
              required: true,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
            defaultValue: "",
            template: "<span>{{ item.label }}</span>",
            input: true,
          },

          // this is for nsw and all other states
          {
            type: "select",
            label: "Business Type/Activity",
            key: "respondentBusinessType",
            placeholder: "Select one",
            data: {
              values: [
                { value: "Principal", label: "Principal" },
                { value: "Head contractor", label: "Head contractor" },
                { value: "Subcontractor", label: "Subcontractor" },
                { value: "Supplier", label: "Supplier" },
                { value: "Consultant", label: "Consultant" },
                { value: "Not Specified", label: "Not Specified" },
              ],
            },
            dataSrc: "values",
            validate: {
              required: true,
            },
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.terms" }, "yes"] },
                  {
                    in: [
                      { var: "data.applicantState" },
                      ["NSW", "SA", "ACT", "TAS"],
                    ],
                  },
                ],
              },
            },
            defaultValue: "",
            template: "<span>{{ item.label }}</span>",
            input: true,
          },

          // this is for VIC - has special list
          {
            type: "select",
            label: "Business Type/Activity",
            key: "respondentBusinessType",
            placeholder: "Select one",
            data: {
              values: [
                { value: "Consultant", label: "Consultant" },
                { value: "Developer", label: "Developer" },
                { value: "Head contractor", label: "Head contractor" },
                { value: "Major subcontractor", label: "Major subcontractor" },
                {
                  value: "Manufacturer of building materials or components",
                  label: "Manufacturer of building materials or components",
                },
                { value: "Project manager", label: "Project manager" },
                { value: "Supplier", label: "Supplier" },
                { value: "Trade subcontractor", label: "Trade subcontractor" },
                { value: "Other", label: "Other" },
              ],
            },
            dataSrc: "values",
            validate: {
              required: true,
            },
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.terms" }, "yes"] },
                  { "===": [{ var: "data.applicantState" }, "VIC"] },
                ],
              },
            },
            defaultValue: "",
            template: "<span>{{ item.label }}</span>",
            input: true,
          },

          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Contact Person",
            inputMask: "",
            key: "respondentContactPersonText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "respondentContactPersonName",
            placeholder: "Name",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "respondentContactPersonPosition",
            placeholder: "Position",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Address",
            inputMask: "",
            key: "respondentAddressText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "respondentAddressNumberStreet",
            placeholder: "Number/Street",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "respondentSuburb",
            placeholder: "Suburb",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "respondentState",
            placeholder: "State",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "respondentPostCode",
            placeholder: "Postcode",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            label: "Phone",
            inputMask: "(99) 9999-9999",
            tableView: true,
            persistent: true,
            validate: {
              required: false,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
            key: "respondentPhone",
            type: "textfield",
            input: true,
          },
          {
            label: "Fax",
            inputMask: "(99) 9999-9999",
            tableView: true,
            persistent: true,
            validate: {
              required: false,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
            key: "respondentFax",
            type: "textfield",
            input: true,
          },
          {
            label: "Email",
            tableView: true,
            validate: {
              required: true,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
            key: "respondentEmail",
            type: "email",
            input: true,
          },
          {
            type: "select",
            label: "Does the respondent retain advisors?",
            key: "respondentRetainAdvisers",
            placeholder: "Select one",
            data: {
              values: [
                { value: "responsePreparer", label: "Response preparer" },
                { value: "consultant", label: "Consultant" },
                { value: "solicitors", label: "Solicitors" },
                { value: "none", label: "None" },
                { value: "notKnown", label: "Not known" },
              ],
            },
            dataSrc: "values",
            defaultValue: "",
            template: "<span>{{ item.label }}</span>",
            input: true,
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          //start for retain advisors
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Contact Person",
            inputMask: "",
            key: "respondentRetailAdvisorContactPersonText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            conditional: {
              json: {
                in: [
                  {
                    var: "data.respondentRetainAdvisers",
                  },
                  ["responsePreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "respondentRetailAdvisorContactPersonName",
            placeholder: "Name",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.respondentRetainAdvisers",
                  },
                  ["responsePreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "respondentRetailAdvisorContactPersonPosition",
            placeholder: "Position",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.respondentRetainAdvisers",
                  },
                  ["responsePreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Address",
            inputMask: "",
            key: "respondentRetailAdvisorAddressText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            conditional: {
              json: {
                in: [
                  {
                    var: "data.respondentRetainAdvisers",
                  },
                  ["responsePreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "respondentRetailAdvisorAddressNumberStreet",
            placeholder: "Number/Street",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.respondentRetainAdvisers",
                  },
                  ["responsePreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "respondentRetailAdvisorSuburb",
            placeholder: "Suburb",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.respondentRetainAdvisers",
                  },
                  ["responsePreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "respondentRetailAdvisorState",
            placeholder: "State",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.respondentRetainAdvisers",
                  },
                  ["responsePreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "",
            key: "respondentRetailAdvisorPostCode",
            placeholder: "Postcode",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.respondentRetainAdvisers",
                  },
                  ["responsePreparer", "consultant", "solicitors"],
                ],
              },
            },
          },
          {
            label: "Phone",
            inputMask: "(99) 9999-9999",
            tableView: true,
            persistent: true,
            validate: {
              required: false,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.respondentRetainAdvisers",
                  },
                  ["responsePreparer", "consultant", "solicitors"],
                ],
              },
            },
            key: "respondentRetailAdvisorPhone",
            type: "textfield",
            input: true,
          },
          {
            label: "Fax",
            inputMask: "(99) 9999-9999",
            tableView: true,
            persistent: true,
            validate: {
              required: false,
              customPrivate: false,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.respondentRetainAdvisers",
                  },
                  ["responsePreparer", "consultant", "solicitors"],
                ],
              },
            },
            key: "respondentRetailAdvisorFax",
            type: "textfield",
            input: true,
          },
          {
            label: "Email",
            tableView: true,
            validate: {
              required: true,
            },
            conditional: {
              json: {
                in: [
                  {
                    var: "data.respondentRetainAdvisers",
                  },
                  ["responsePreparer", "consultant", "solicitors"],
                ],
              },
            },
            key: "respondentRetailAdvisorEmail",
            type: "email",
            input: true,
          },
        ],
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },
      // end all fields from beginning for respondent
      {
        title: "Details of Authorised Nominating Authority",
        collapsible: true,
        key: "prescribedAppointerPanel",
        type: "panel",
        label: "Panel",
        input: false,
        tableView: false,
        components: [
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "Company Name",
            key: "prescribedAppointerName",
            placeholder: "",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: this.Company_Name,
            protected: false,
            unique: false,
            persistent: true,
            disabled: true,
            validate: {
              required: true,
              customPrivate: false,
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "ABN/ACN",
            key: "prescribedAppointerABN",
            placeholder: "",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: this.ABN_ACN,
            protected: false,
            unique: false,
            persistent: true,
            disabled: true,
          },
          // Start - Address, tele and email
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "Address Line 1",
            key: "prescribedAppointerPostalAddress1",
            placeholder: "",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: this.Address_Line_1,
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            disabled: true,
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "Address Line 2",
            key: "prescribedAppointerPostalAddress2",
            placeholder: "",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: this.Address_Line_2,
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              // "required": true,
              customPrivate: false,
            },
            disabled: true,
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "Suburb",
            key: "prescribedAppointerSuburb",
            placeholder: "",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: this.Suburb,
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            disabled: true,
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "State",
            key: "prescribedAppointerState",
            placeholder: "",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: this.State,
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            disabled: true,
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label: "PostCode",
            key: "prescribedAppointerPostCode",
            placeholder: "",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: this.Postcode,
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
              pattern: "^[0-9]+$",
            },
            disabled: true,
          },
          {
            label: "Telephone number",
            //"inputMask": "(99) 9999-9999",
            tableView: true,
            persistent: true,
            defaultValue: this.Telephone_number,
            validate: {
              required: false,
              customPrivate: false,
            },
            key: "prescribedAppointerTelephoneNumber",
            type: "textfield",
            input: true,
            disabled: true,
          },
          {
            label: "Fax number",
            //"inputMask": "(99) 9999-9999",
            tableView: true,
            persistent: true,
            defaultValue: this.Fax_number,
            validate: {
              required: false,
              customPrivate: false,
            },
            key: "prescribedAppointerFaxNumber",
            type: "textfield",
            input: true,
            disabled: true,
          },
          {
            label: "Email",
            tableView: true,
            defaultValue: this.Email,
            validate: {
              required: true,
            },
            key: "prescribedAppointerEmail",
            type: "email",
            input: true,
            disabled: true,
          },
        ],
        conditional: {
          json: {
            and: [
              { "==": [{ var: "data.terms" }, "yes"] },
              { "===": [{ var: "data.applicantState" }, "WA"] },
            ],
          },
        },
      }, // Details of Authorised Nominating Authority
      {
        type: "radio",
        label:
          "Does the contract fall under the definition of a contract for construction work or related good & services as per the Act?",
        input: true,
        inline: true,
        tableView: false,
        key: "contractDefinition",
        persistent: true,
        values: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        validate: {
          required: true,
        },
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },
      //separate for each state
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "Your claim may be invalid under <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/nsw/consol_act/bacisopa1999606/s5.html' target='_blank'>S5</a> and <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/nsw/consol_act/bacisopa1999606/s6.html' target='_blank'>S6</a> of NSW Building and Construction Security of Payments Act",
        inputMask: "",
        key: "contractNotUnderDefinitionText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        customClass: "orangeText",
        conditional: {
          json: {
            and: [
              { "==": [{ var: "data.contractDefinition" }, "no"] },
              { "===": [{ var: "data.applicantState" }, "NSW"] },
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "Your claim may be invalid under <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/vic/consol_act/bacisopa2002606/s5.html' target='_blank'>S5</a> and <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/vic/consol_act/bacisopa2002606/s6.html' target='_blank'>S6</a> of VIC Building and Construction Security of Payments Act",
        inputMask: "",
        key: "contractNotUnderDefinitionText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        customClass: "orangeText",
        conditional: {
          json: {
            and: [
              { "==": [{ var: "data.contractDefinition" }, "no"] },
              { "===": [{ var: "data.applicantState" }, "VIC"] },
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "Your claim may be invalid under <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/sa/consol_act/bacisopa2009606/s5.html' target='_blank'>S5</a> and <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/sa/consol_act/bacisopa2009606/s6.html' target='_blank'>S6</a> of SA BCISP",
        inputMask: "",
        key: "contractNotUnderDefinitionText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        customClass: "orangeText",
        conditional: {
          json: {
            and: [
              { "==": [{ var: "data.contractDefinition" }, "no"] },
              { "===": [{ var: "data.applicantState" }, "SA"] },
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "Your claim may be invalid under <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/tas/consol_act/bacisopa2009606/s5.html' target='_blank'>S5</a> and <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/tas/consol_act/bacisopa2009606/s6.html' target='_blank'>S6</a> of TAS BCISP",
        inputMask: "",
        key: "contractNotUnderDefinitionText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        customClass: "orangeText",
        conditional: {
          json: {
            and: [
              { "==": [{ var: "data.contractDefinition" }, "no"] },
              { "===": [{ var: "data.applicantState" }, "TAS"] },
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "Your claim may be invalid under <a href='http://www6.austlii.edu.au/cgi-bin/viewdoc/au/legis/act/consol_act/baciopa2009606/s7.html' target='_blank'>S7</a> and <a href='http://www6.austlii.edu.au/cgi-bin/viewdoc/au/legis/act/consol_act/baciopa2009606/s8.html' target='_blank'>S8</a> of ACT BCISP",
        inputMask: "",
        key: "contractNotUnderDefinitionText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        customClass: "orangeText",
        conditional: {
          json: {
            and: [
              { "==": [{ var: "data.contractDefinition" }, "no"] },
              { "===": [{ var: "data.applicantState" }, "ACT"] },
            ],
          },
        },
      },
      {
        label: "Date construction contract was entered into",
        format: "dd-MMM-yyyy",
        tableView: false,
        enableMinDateInput: false,
        datePicker: {
          disableWeekends: false,
          disableWeekdays: false,
        },
        enableMaxDateInput: false,
        enableTime: false,
        timePicker: {
          showMeridian: false,
        },
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
        key: "dateConstructionContractWasEnteredInto",
        type: "datetime",
        input: true,
        widget: {
          type: "calendar",
          displayInTimezone: "viewer",
          locale: "en",
          useLocaleSettings: false,
          allowInput: true,
          mode: "single",
          enableTime: false,
          noCalendar: false,
          format: "dd-MMM-yyyy",
          hourIncrement: 1,
          minuteIncrement: 1,
          time_24hr: true,
          minDate: null,
          disableWeekends: false,
          disableWeekdays: false,
          maxDate: null,
        },
      },
      {
        label:
          "Last date on which the relevant construction work was carried out",
        format: "dd-MMM-yyyy",
        tableView: false,
        enableMinDateInput: false,
        datePicker: {
          disableWeekends: false,
          disableWeekdays: false,
        },
        enableMaxDateInput: false,
        enableTime: false,
        timePicker: {
          showMeridian: false,
        },
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
        key: "lastDateRelevantConstructionWorkCarriedOut",
        type: "datetime",
        input: true,
        widget: {
          type: "calendar",
          displayInTimezone: "viewer",
          locale: "en",
          useLocaleSettings: false,
          allowInput: true,
          mode: "single",
          enableTime: false,
          noCalendar: false,
          format: "dd-MMM-yyyy",
          hourIncrement: 1,
          minuteIncrement: 1,
          time_24hr: true,
          minDate: null,
          disableWeekends: false,
          disableWeekdays: false,
          maxDate: null,
        },
        validate: {
          required: true,
        },
      },

      // Add blurb based on state
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "Your claim may be invalid under s13(4) of the Act. Please check your contract to see if there is an extension on payment claim windows.",
        inputMask: "",
        key: "lastDateOfRelaventConstructionConditionText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        customClass: "orangeText",
        conditional: {
          json: {
            and: [
              { "==": [{ var: "data.applicantState" }, "NSW"] },
              {
                "!=": [
                  { var: "data.lastDateRelevantConstructionWorkCarriedOut" },
                  "",
                ],
              },
              {
                "<": [
                  { var: "data.lastDateRelevantConstructionWorkCarriedOut" },
                  todayMinus12Months,
                ],
              },
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "Please check your contract to determine that the reference date as defined in s9(2) of the Act occurred less than 3 months ago.",
        inputMask: "",
        key: "lastDateOfRelaventConstructionConditionText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        customClass: "orangeText",
        conditional: {
          json: {
            and: [
              { "==": [{ var: "data.applicantState" }, "VIC"] },
              {
                "!=": [
                  { var: "data.lastDateRelevantConstructionWorkCarriedOut" },
                  "",
                ],
              },
              {
                "<": [
                  { var: "data.lastDateRelevantConstructionWorkCarriedOut" },
                  todayMinus3Months,
                ],
              },
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "Your claim may be invalid under s13(4) of the Act. Please check your contract to see if there is an extension on payment claim windows.",
        inputMask: "",
        key: "lastDateOfRelaventConstructionConditionText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        customClass: "orangeText",
        conditional: {
          json: {
            and: [
              { "==": [{ var: "data.applicantState" }, "SA"] },
              {
                "!=": [
                  { var: "data.lastDateRelevantConstructionWorkCarriedOut" },
                  "",
                ],
              },
              {
                "<": [
                  { var: "data.lastDateRelevantConstructionWorkCarriedOut" },
                  todayMinus6Months,
                ],
              },
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "Your claim may be invalid under s17 of the Act. Please check your contract to see if there is an extension on payment claim windows.",
        inputMask: "",
        key: "lastDateOfRelaventConstructionConditionText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        customClass: "orangeText",
        conditional: {
          json: {
            and: [
              { "==": [{ var: "data.applicantState" }, "TAS"] },
              {
                "!=": [
                  { var: "data.lastDateRelevantConstructionWorkCarriedOut" },
                  "",
                ],
              },
              {
                "<": [
                  { var: "data.lastDateRelevantConstructionWorkCarriedOut" },
                  todayMinus12Months,
                ],
              },
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "Your claim may be invalid under s15(4) of the Act. Please check your contract to see if there is an extension on payment claim windows.",
        inputMask: "",
        key: "lastDateOfRelaventConstructionConditionText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        customClass: "orangeText",
        conditional: {
          json: {
            and: [
              { "==": [{ var: "data.applicantState" }, "ACT"] },
              {
                "!=": [
                  { var: "data.lastDateRelevantConstructionWorkCarriedOut" },
                  "",
                ],
              },
              {
                "<": [
                  { var: "data.lastDateRelevantConstructionWorkCarriedOut" },
                  todayMinus12Months,
                ],
              },
            ],
          },
        },
      },
      {
        type: "textarea",
        input: true,
        tableView: true,
        inputType: "text",
        inputMask: "",
        label: "Description of project",
        key: "projectDescription",
        placeholder: "",
        prefix: "",
        suffix: "",
        multiple: false,
        defaultValue: "",
        protected: false,
        unique: false,
        persistent: true,
        validate: {
          required: true,
          customPrivate: false,
        },
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },
      {
        type: "textfield",
        input: true,
        tableView: true,
        inputType: "text",
        inputMask: "",
        label: "Postcode in which the relevant construction work took place",
        key: "relaventConstructionPostCode",
        placeholder: "",
        prefix: "",
        suffix: "",
        multiple: false,
        defaultValue: "",
        protected: false,
        unique: false,
        persistent: true,
        validate: {
          required: true,
          customPrivate: false,
        },
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },
      {
        type: "radio",
        label:
          "Is the contract between a contractor and individual principal for home building work for a contract sum greater than $500,000 (incl. GST)?",
        input: true,
        inline: true,
        tableView: false,
        key: "contractConfirmation",
        persistent: true,
        values: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
          { value: "na", label: "Not applicable (not home building work)" },
        ],
        validate: {
          required: false,
        },
        conditional: {
          json: {
            and: [
              { "==": [{ var: "data.terms" }, "yes"] },
              { "===": [{ var: "data.applicantState" }, "WA"] },
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "Please check <a href='https://classic.austlii.edu.au/au/legis/wa/num_act/baciopa20214o2021652/s10.html' target='_blank'>s10</a> of the Act",
        inputMask: "",
        key: "applicantNswText",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        conditional: {
          json: {
            and: [
              { "==": [{ var: "data.contractConfirmation" }, "no"] },
              { "==": [{ var: "data.terms" }, "yes"] },
              { "===": [{ var: "data.applicantState" }, "WA"] },
            ],
          },
        },
      },
      {
        type: "fileupload",
        label: "Claimant submissons (contract documents)",
        disabled: false,
        placeholder: "Claimant contract documents",
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },
      {
        type: "fileupload",
        label: "Claimant submissons (supporting documents)",
        disabled: false,
        placeholder: "Claimant supporting documents",
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },

      // Start panel
      {
        title: "Payment claim",
        collapsible: false,
        key: "panel",
        type: "panel",
        label: "Panel",
        input: false,
        tableView: false,
        components: [
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "The relevant details regarding payment claims can be found in the Act",
            inputMask: "",
            key: "relaventDetailsRegardingPaymentText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "radio",
            label: "Was a payment claim served",
            input: true,
            inline: true,
            tableView: false,
            key: "paymentClaimServed",
            persistent: true,
            values: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
            validate: {
              required: true,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/nsw/consol_act/bacisopa1999606/s13.html' target='_blank'>S13</a>",
            inputMask: "",
            key: "claimUnderLegislationText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "NSW"] },
                  { "===": [{ var: "data.paymentClaimServed" }, "no"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/vic/consol_act/bacisopa2002606/s14.html' target='_blank'>S14</a>",
            inputMask: "",
            key: "claimUnderLegislationText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "VIC"] },
                  { "===": [{ var: "data.paymentClaimServed" }, "no"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/sa/consol_act/bacisopa2009606/s13.html' target='_blank'>S13</a>",
            inputMask: "",
            key: "claimUnderLegislationText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "SA"] },
                  { "===": [{ var: "data.paymentClaimServed" }, "no"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/tas/consol_act/bacisopa2009606/s17.html' target='_blank'>S17</a>",
            inputMask: "",
            key: "claimUnderLegislationText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "TAS"] },
                  { "===": [{ var: "data.paymentClaimServed" }, "no"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www6.austlii.edu.au/cgi-bin/viewdoc/au/legis/act/consol_act/baciopa2009606/s15.html' target='_blank'>S15</a>",
            inputMask: "",
            key: "claimUnderLegislationText",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "ACT"] },
                  { "===": [{ var: "data.paymentClaimServed" }, "no"] },
                ],
              },
            },
          },
          {
            type: "radio",
            label: "Did the claim state that the claim was made under the Act",
            input: true,
            inline: true,
            tableView: false,
            key: "claimUnderLegislation",
            persistent: true,
            values: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
            validate: {
              required: true,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/nsw/consol_act/bacisopa1999606/s13.html' target='_blank'>S13</a>",
            inputMask: "",
            key: "claimUnderLegislationText1",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "NSW"] },
                  { "===": [{ var: "data.claimUnderLegislation" }, "no"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/vic/consol_act/bacisopa2002606/s14.html' target='_blank'>S14</a>",
            inputMask: "",
            key: "claimUnderLegislationText1",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "VIC"] },
                  { "===": [{ var: "data.claimUnderLegislation" }, "no"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/sa/consol_act/bacisopa2009606/s13.html' target='_blank'>S13</a>",
            inputMask: "",
            key: "claimUnderLegislationText1",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "SA"] },
                  { "===": [{ var: "data.claimUnderLegislation" }, "no"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/tas/consol_act/bacisopa2009606/s17.html' target='_blank'>S17</a>",
            inputMask: "",
            key: "claimUnderLegislationText1",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "TAS"] },
                  { "===": [{ var: "data.claimUnderLegislation" }, "no"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www6.austlii.edu.au/cgi-bin/viewdoc/au/legis/act/consol_act/baciopa2009606/s15.html' target='_blank'>S15</a>",
            inputMask: "",
            key: "claimUnderLegislationText1",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "ACT"] },
                  { "===": [{ var: "data.claimUnderLegislation" }, "no"] },
                ],
              },
            },
          },
          {
            type: "radio",
            label:
              "Did the payment claim identify the relevant work or related goods and services?",
            input: true,
            inline: true,
            tableView: false,
            key: "paymentClaimIdentifyRelaventWork",
            persistent: true,
            values: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
            validate: {
              required: true,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/nsw/consol_act/bacisopa1999606/s13.html' target='_blank'>S13</a>",
            inputMask: "",
            key: "claimUnderLegislationText3",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "NSW"] },
                  {
                    "===": [
                      { var: "data.paymentClaimIdentifyRelaventWork" },
                      "no",
                    ],
                  },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/vic/consol_act/bacisopa2002606/s14.html' target='_blank'>S14</a>",
            inputMask: "",
            key: "claimUnderLegislationText3",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "VIC"] },
                  {
                    "===": [
                      { var: "data.paymentClaimIdentifyRelaventWork" },
                      "no",
                    ],
                  },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/sa/consol_act/bacisopa2009606/s13.html' target='_blank'>S13</a>",
            inputMask: "",
            key: "claimUnderLegislationText3",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "SA"] },
                  {
                    "===": [
                      { var: "data.paymentClaimIdentifyRelaventWork" },
                      "no",
                    ],
                  },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/tas/consol_act/bacisopa2009606/s17.html' target='_blank'>S17</a>",
            inputMask: "",
            key: "claimUnderLegislationText3",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "TAS"] },
                  {
                    "===": [
                      { var: "data.paymentClaimIdentifyRelaventWork" },
                      "no",
                    ],
                  },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under the Act, please check <a href='http://www6.austlii.edu.au/cgi-bin/viewdoc/au/legis/act/consol_act/baciopa2009606/s15.html' target='_blank'>S15</a>",
            inputMask: "",
            key: "claimUnderLegislationText3",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "ACT"] },
                  {
                    "===": [
                      { var: "data.paymentClaimIdentifyRelaventWork" },
                      "no",
                    ],
                  },
                ],
              },
            },
          },
          //fileupload
          //{
          //  "type": "fileupload",
          //  "label": "Please upload a copy of the payment claim",
          //  "disabled": false,
          //  "placeholder": "paymentClaimDocs",
          //  conditional: {
          //    "json": {
          //      "===": [
          //        {
          //          "var": "data.terms"
          //        },
          //        "yes"
          //      ]
          //    }
          //  }
          //},
          // Adding the extra fields
          // {
          //   "type": "radio",
          //   "label": "Does the payment schedule identify the Payment Claim to which it relates?",
          //   "input": true,
          //   "inline": true,
          //   "tableView": false,
          //   "key": "paymentScheduleIdentifyPaymentClaim",
          //   "persistent": true,
          //     values: [
          //       {value: 'yes', label: 'Yes'},
          //       {value: 'no', label: 'No'}
          //     ],
          //     "validate": {
          //       "required": true
          //   },
          //   conditional: {
          //     "json": {
          //       "===": [
          //         {
          //           "var": "data.terms"
          //         },
          //         "yes"
          //       ]
          //     }
          //   }
          // },
          //
          {
            label: "Claimed amount (excl. GST) as specified in Claim",
            mask: false,
            spellcheck: true,
            tableView: false,
            currency: "AUD",
            inputFormat: "plain",
            key: "claimedAmount",
            type: "currency",
            input: true,
            delimiter: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            label: "Date of Claim",
            format: "dd-MMM-yyyy",
            tableView: false,
            enableMinDateInput: false,
            datePicker: {
              disableWeekends: false,
              disableWeekdays: false,
            },
            enableMaxDateInput: false,
            enableTime: false,
            timePicker: {
              showMeridian: false,
            },
            key: "dateOfClaim",
            type: "datetime",
            input: true,
            widget: {
              type: "calendar",
              displayInTimezone: "viewer",
              locale: "en",
              useLocaleSettings: false,
              allowInput: true,
              mode: "single",
              enableTime: false,
              noCalendar: false,
              format: "dd-MMM-yyyy",
              hourIncrement: 1,
              minuteIncrement: 1,
              time_24hr: true,
              minDate: null,
              disableWeekends: false,
              disableWeekdays: false,
              maxDate: null,
            },
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },

          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your payment claim may be ineligible under s13 (4)(b) of the Act",
            inputMask: "",
            key: "claimUnderLegislationText3",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    "==": [{ var: "data.displayOnDateOfClaimCheckNSW" }, true],
                  },
                  { "===": [{ var: "data.applicantState" }, "NSW"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your payment claim may be ineligible under s17 (6)(b) of the Act",
            inputMask: "",
            key: "claimUnderLegislationText3SACheck",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.displayOnDateOfClaimCheckSA" }, true] },
                  { "===": [{ var: "data.applicantState" }, "SA"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your payment claim may be ineligible under s15 (4)(b) of the Act",
            inputMask: "",
            key: "claimUnderLegislationText3ACTCheck",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    "==": [{ var: "data.displayOnDateOfClaimCheckACT" }, true],
                  },
                  { "===": [{ var: "data.applicantState" }, "ACT"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your payment claim may be ineligible under s17 (6)(b) of the Act",
            inputMask: "",
            key: "claimUnderLegislationText3ACTCheck",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    "==": [{ var: "data.displayOnDateOfClaimCheckTAS" }, true],
                  },
                  { "===": [{ var: "data.applicantState" }, "TAS"] },
                ],
              },
            },
          },

          {
            label: "Date served",
            format: "dd-MMM-yyyy",
            tableView: false,
            enableMinDateInput: false,
            datePicker: {
              disableWeekends: false,
              disableWeekdays: false,
            },
            enableMaxDateInput: false,
            enableTime: false,
            timePicker: {
              showMeridian: false,
            },
            key: "dateServed",
            type: "datetime",
            input: true,
            widget: {
              type: "calendar",
              displayInTimezone: "viewer",
              locale: "en",
              useLocaleSettings: false,
              allowInput: true,
              mode: "single",
              enableTime: false,
              noCalendar: false,
              format: "dd-MMM-yyyy",
              hourIncrement: 1,
              minuteIncrement: 1,
              time_24hr: true,
              minDate: null,
              disableWeekends: false,
              disableWeekdays: false,
              maxDate: null,
            },
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            label: "Due date for payment",
            format: "dd-MMM-yyyy",
            tableView: false,
            enableMinDateInput: false,
            datePicker: {
              disableWeekends: false,
              disableWeekdays: false,
            },
            enableMaxDateInput: false,
            enableTime: false,
            timePicker: {
              showMeridian: false,
            },
            key: "dueDatForPayment",
            type: "datetime",
            input: true,
            widget: {
              type: "calendar",
              displayInTimezone: "viewer",
              locale: "en",
              useLocaleSettings: false,
              allowInput: true,
              mode: "single",
              enableTime: false,
              noCalendar: false,
              format: "dd-MMM-yyyy",
              hourIncrement: 1,
              minuteIncrement: 1,
              time_24hr: true,
              minDate: null,
              disableWeekends: false,
              disableWeekdays: false,
              maxDate: null,
            },
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            label: "What is  the 'reference date' for the payment claim?",
            format: "dd-MMM-yyyy",
            tableView: false,
            enableMinDateInput: false,
            datePicker: {
              disableWeekends: false,
              disableWeekdays: false,
            },
            enableMaxDateInput: false,
            enableTime: false,
            timePicker: {
              showMeridian: false,
            },
            key: "referenceDate",
            type: "datetime",
            input: true,
            widget: {
              type: "calendar",
              displayInTimezone: "viewer",
              locale: "en",
              useLocaleSettings: false,
              allowInput: true,
              mode: "single",
              enableTime: false,
              noCalendar: false,
              format: "dd-MMM-yyyy",
              hourIncrement: 1,
              minuteIncrement: 1,
              time_24hr: true,
              minDate: null,
              disableWeekends: false,
              disableWeekdays: false,
              maxDate: null,
            },
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.applicantState",
                  },
                  "VIC",
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your payment claim may be ineligible under s14 (4)(b) of the Act",
            inputMask: "",
            key: "claimUnderLegislationText4",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.checkReferenceDateValidation",
                  },
                  "yes",
                ],
              },
            },
          },
          /////////////////////////////////////////////////////////////
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under <a href='http://www8.austlii.edu.au/cgi-bin/viewdb/au/legis/nsw/consol_act/bacisopa1999606/' target='_blank'>(relevant section)</a>. Please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdb/au/legis/nsw/consol_act/bacisopa1999606/' target='_blank'>(relevant section)</a> for appropriate timeframes.",
            inputMask: "",
            key: "blurbForPaymentScheduleUpload",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.DateServedAndDateOfPaymentValidation_NSW",
                  },
                  true,
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under <a href='http://www6.austlii.edu.au/cgi-bin/viewdoc/au/legis/vic/consol_act/bacisopa2002606/s18.html' target='_blank'>s18</a>. Please check <a href='http://www6.austlii.edu.au/cgi-bin/viewdoc/au/legis/vic/consol_act/bacisopa2002606/s18.html' target='_blank'>s18</a> for appropriate timeframes.",
            inputMask: "",
            key: "blurbForPaymentScheduleUpload",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.DateServedAndDateOfPaymentValidation_VIC",
                  },
                  true,
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/sa/consol_act/bacisopa2009606/s17.html' target='_blank'>s17</a>. Please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/sa/consol_act/bacisopa2009606/s17.html' target='_blank'>s17</a> for appropriate timeframes.",
            inputMask: "",
            key: "blurbForPaymentScheduleUpload",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.DateServedAndDateOfPaymentValidation_SA",
                  },
                  true,
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/act/consol_act/baciopa2009606/s19.html' target='_blank'>s19</a>. Please check <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/act/consol_act/baciopa2009606/s19.html' target='_blank'>s19</a> for appropriate timeframes.",
            inputMask: "",
            key: "blurbForPaymentScheduleUpload",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.DateServedAndDateOfPaymentValidation_ACT",
                  },
                  true,
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Your claim may be invalid under <a href='http://www6.austlii.edu.au/cgi-bin/viewdoc/au/legis/tas/consol_act/bacisopa2009606/s21.html' target='_blank'>s21</a>. Please check <a href='http://www6.austlii.edu.au/cgi-bin/viewdoc/au/legis/tas/consol_act/bacisopa2009606/s21.html' target='_blank'>s21</a> for appropriate timeframes.",
            inputMask: "",
            key: "blurbForPaymentScheduleUpload",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.DateServedAndDateOfPaymentValidation_TAS",
                  },
                  true,
                ],
              },
            },
          },
        ],
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },
      {
        type: "fileupload",
        label: "Please upload a copy of the payment claim",
        disabled: false,
        placeholder: "Payment claim documents",
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },
      // end panel
      // start payment schedule panel
      {
        title: "Payment schedule",
        collapsible: true,
        key: "panel",
        type: "panel",
        label: "Panel",
        input: false,
        tableView: false,
        components: [
          {
            type: "radio",
            label:
              "The relevant details regarding payment schedules can be found in the Act. Was a payment Schedule served?",
            input: true,
            inline: true,
            tableView: false,
            key: "relaventDetailsRegardingPaymentSchedule",
            persistent: true,
            values: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
            validate: {
              required: true,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          // {
          //   "type": "htmlelement",
          //   "input": false,
          //   "tableView": true,
          //   "content": "Your payment claim may be ineligible under s14 (4)(b) of the Act",
          //   "inputMask": "",
          //   "key": "claimUnderLegislationText_relaventDetailsRegardingPaymentSchedule",
          //   "prefix": "",
          //   "suffix": "",
          //   "multiple": false,
          //   "protected": false,
          //   "unique": false,
          //   "persistent": true,
          //   "customClass": "orangeText",
          //   "conditional": {
          //     "json": {
          //       "===": [
          //         {
          //           "var": "data.relaventDetailsRegardingPaymentSchedule"
          //         },
          //         "no"
          //       ]
          //     }
          //   }
          // },
          {
            type: "radio",
            label: "Did the payment schedule Identify the relevant claim?",
            input: true,
            inline: true,
            tableView: false,
            key: "paymentScheduleIdentityRelaventClaim",
            persistent: true,
            values: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
            validate: {
              required: true,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.relaventDetailsRegardingPaymentSchedule",
                  },
                  "yes",
                ],
              },
            },
          },
          // {
          //   "type": "htmlelement",
          //   "input": false,
          //   "tableView": true,
          //   "content": "Your claim may be invalid under <a href='http://www8.austlii.edu.au/cgi-bin/viewdb/au/legis/nsw/consol_act/bacisopa1999606/' target='_blank'>consol act</a>",
          //   "inputMask": "",
          //   "key": "claimUnderLegislationText_paymentScheduleIdentityRelaventClaim",
          //   "prefix": "",
          //   "suffix": "",
          //   "multiple": false,
          //   "protected": false,
          //   "unique": false,
          //   "persistent": true,
          //   "customClass": "orangeText",
          //   "conditional": {
          //     "json": {
          //     "and": [
          //       {"==": [{"var": "data.applicantState"}, "NSW"]},
          //       {"===": [{"var": "data.paymentScheduleIdentityRelaventClaim"}, "no"]},
          //     ],
          //     }
          //   }
          // },
          // {
          //   "type": "htmlelement",
          //   "input": false,
          //   "tableView": true,
          //   "content": "Your claim may be invalid under <a href='http://www6.austlii.edu.au/cgi-bin/viewdoc/au/legis/vic/consol_act/bacisopa2002606/s18.html' target='_blank'>s18</a>",
          //   "inputMask": "",
          //   "key": "claimUnderLegislationText_paymentScheduleIdentityRelaventClaim",
          //   "prefix": "",
          //   "suffix": "",
          //   "multiple": false,
          //   "protected": false,
          //   "unique": false,
          //   "persistent": true,
          //   "customClass": "orangeText",
          //   "conditional": {
          //     "json": {
          //     "and": [
          //       {"==": [{"var": "data.applicantState"}, "VIC"]},
          //       {"===": [{"var": "data.paymentScheduleIdentityRelaventClaim"}, "no"]},
          //     ],
          //     }
          //   }
          // },
          // {
          //   "type": "htmlelement",
          //   "input": false,
          //   "tableView": true,
          //   "content": "Your claim may be invalid under <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/sa/consol_act/bacisopa2009606/s17.html' target='_blank'>s17</a>",
          //   "inputMask": "",
          //   "key": "claimUnderLegislationText_paymentScheduleIdentityRelaventClaim",
          //   "prefix": "",
          //   "suffix": "",
          //   "multiple": false,
          //   "protected": false,
          //   "unique": false,
          //   "persistent": true,
          //   "customClass": "orangeText",
          //   "conditional": {
          //     "json": {
          //     "and": [
          //       {"==": [{"var": "data.applicantState"}, "SA"]},
          //       {"===": [{"var": "data.paymentScheduleIdentityRelaventClaim"}, "no"]},
          //     ],
          //     }
          //   }
          // },
          // {
          //   "type": "htmlelement",
          //   "input": false,
          //   "tableView": true,
          //   "content": "Your claim may be invalid under <a href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/act/consol_act/baciopa2009606/s19.html' target='_blank'>s19</a>",
          //   "inputMask": "",
          //   "key": "claimUnderLegislationText_paymentScheduleIdentityRelaventClaim",
          //   "prefix": "",
          //   "suffix": "",
          //   "multiple": false,
          //   "protected": false,
          //   "unique": false,
          //   "persistent": true,
          //   "customClass": "orangeText",
          //   "conditional": {
          //     "json": {
          //     "and": [
          //       {"==": [{"var": "data.applicantState"}, "ACT"]},
          //       {"===": [{"var": "data.paymentScheduleIdentityRelaventClaim"}, "no"]},
          //     ],
          //     }
          //   }
          // },
          // {
          //   "type": "htmlelement",
          //   "input": false,
          //   "tableView": true,
          //   "content": "Your claim may be invalid under <a href='http://www6.austlii.edu.au/cgi-bin/viewdoc/au/legis/tas/consol_act/bacisopa2009606/s21.html' target='_blank'>s21</a>",
          //   "inputMask": "",
          //   "key": "claimUnderLegislationText_paymentScheduleIdentityRelaventClaim",
          //   "prefix": "",
          //   "suffix": "",
          //   "multiple": false,
          //   "protected": false,
          //   "unique": false,
          //   "persistent": true,
          //   "customClass": "orangeText",
          //   "conditional": {
          //     "json": {
          //     "and": [
          //       {"==": [{"var": "data.applicantState"}, "TAS"]},
          //       {"===": [{"var": "data.paymentScheduleIdentityRelaventClaim"}, "no"]},
          //     ],
          //     }
          //   }
          // },
          {
            label: "Scheduled amount (excl. GST)",
            mask: false,
            spellcheck: true,
            tableView: false,
            currency: "AUD",
            inputFormat: "plain",
            key: "scheduledAmount",
            type: "currency",
            input: true,
            delimiter: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.relaventDetailsRegardingPaymentSchedule",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "textfield",
            input: true,
            tableView: true,
            inputType: "text",
            inputMask: "",
            label:
              "If the scheduled amount was less than claimed amount, what are the reasons for withholding the difference?",
            key: "reasonForWithholding",
            placeholder: "",
            prefix: "",
            suffix: "",
            multiple: false,
            defaultValue: "",
            protected: false,
            unique: false,
            persistent: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                and: [
                  {
                    "<": [
                      { var: "data.scheduledAmount" },
                      { var: "data.claimedAmount" },
                    ],
                  },
                  {
                    "===": [
                      { var: "data.relaventDetailsRegardingPaymentSchedule" },
                      "yes",
                    ],
                  },
                ],
              },
            },
          },
          {
            label: "Schedule Date",
            format: "dd-MMM-yyyy",
            tableView: false,
            enableMinDateInput: false,
            datePicker: {
              disableWeekends: false,
              disableWeekdays: false,
            },
            enableMaxDateInput: false,
            enableTime: false,
            timePicker: {
              showMeridian: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.relaventDetailsRegardingPaymentSchedule",
                  },
                  "yes",
                ],
              },
            },
            key: "scheduleDate",
            type: "datetime",
            input: true,
            widget: {
              type: "calendar",
              displayInTimezone: "viewer",
              locale: "en",
              useLocaleSettings: false,
              allowInput: true,
              mode: "single",
              enableTime: false,
              noCalendar: false,
              format: "dd-MMM-yyyy",
              hourIncrement: 1,
              minuteIncrement: 1,
              time_24hr: true,
              minDate: null,
              disableWeekends: false,
              disableWeekdays: false,
              maxDate: null,
            },
          },
          {
            label: "Date received",
            format: "dd-MMM-yyyy",
            tableView: false,
            enableMinDateInput: false,
            datePicker: {
              disableWeekends: false,
              disableWeekdays: false,
            },
            enableMaxDateInput: false,
            enableTime: false,
            timePicker: {
              showMeridian: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.relaventDetailsRegardingPaymentSchedule",
                  },
                  "yes",
                ],
              },
            },
            key: "dateReceived",
            type: "datetime",
            input: true,
            widget: {
              type: "calendar",
              displayInTimezone: "viewer",
              locale: "en",
              useLocaleSettings: false,
              allowInput: true,
              mode: "single",
              enableTime: false,
              noCalendar: false,
              format: "dd-MMM-yyyy",
              hourIncrement: 1,
              minuteIncrement: 1,
              time_24hr: true,
              minDate: null,
              disableWeekends: false,
              disableWeekdays: false,
              maxDate: null,
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s17(3)(d) of the Act",
            inputMask: "",
            key: "claimInvalid_s17_NSW",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    "===": [
                      { var: "data.claimedAmount" },
                      { var: "data.scheduledAmount" },
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "NSW"] },
                  { "!=": [{ var: "data.dateReceived" }, ""] },
                  { "<": [{ var: "data.dateReceived" }, todayMinus20] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s18(3)(d) of the Act",
            inputMask: "",
            key: "claimInvalid_s17_VIC",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    "===": [
                      { var: "data.claimedAmount" },
                      { var: "data.scheduledAmount" },
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "VIC"] },
                  { "!=": [{ var: "data.dateReceived" }, ""] },
                  { "<": [{ var: "data.dateReceived" }, todayMinus10] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s17(3)(d) of the Act",
            inputMask: "",
            key: "claimInvalid_s17_SA",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    "===": [
                      { var: "data.claimedAmount" },
                      { var: "data.scheduledAmount" },
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "SA"] },
                  { "!=": [{ var: "data.dateReceived" }, ""] },
                  { "<": [{ var: "data.dateReceived" }, todayMinus20] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s19(3)(c) of the Act",
            inputMask: "",
            key: "claimInvalid_s17_ACT",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    "===": [
                      { var: "data.claimedAmount" },
                      { var: "data.scheduledAmount" },
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "ACT"] },
                  { "!=": [{ var: "data.dateReceived" }, ""] },
                  { "<": [{ var: "data.dateReceived" }, todayMinus20] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s21(3) of the Act",
            inputMask: "",
            key: "claimInvalid_s17_TAS",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    "===": [
                      { var: "data.claimedAmount" },
                      { var: "data.scheduledAmount" },
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "TAS"] },
                  { "!=": [{ var: "data.dateReceived" }, ""] },
                  { "<": [{ var: "data.dateReceived" }, todayMinus20] },
                ],
              },
            },
          },
          {
            label: "Due date for payment",
            format: "dd-MMM-yyyy",
            tableView: false,
            enableMinDateInput: false,
            datePicker: {
              disableWeekends: false,
              disableWeekdays: false,
            },
            enableMaxDateInput: false,
            enableTime: false,
            timePicker: {
              showMeridian: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.relaventDetailsRegardingPaymentSchedule",
                  },
                  "yes",
                ],
              },
            },
            key: "dueDateForPaymentSchedule",
            type: "datetime",
            input: true,
            widget: {
              type: "calendar",
              displayInTimezone: "viewer",
              locale: "en",
              useLocaleSettings: false,
              allowInput: true,
              mode: "single",
              enableTime: false,
              noCalendar: false,
              format: "dd-MMM-yyyy",
              hourIncrement: 1,
              minuteIncrement: 1,
              time_24hr: true,
              minDate: null,
              disableWeekends: false,
              disableWeekdays: false,
              maxDate: null,
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s17(3)(c) of the Act",
            inputMask: "",
            key: "dueDateForPayment_InValid_NSW",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    ">": [
                      { var: "data.claimedAmount" },
                      { var: "data.scheduledAmount" },
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "NSW"] },
                  { "!=": [{ var: "data.dueDateForPayment" }, ""] },
                  { "<": [{ var: "data.dueDateForPayment" }, todayMinus10] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s18(3)(c) of the Act",
            inputMask: "",
            key: "dueDateForPayment_InValid_VIC",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    ">": [
                      { var: "data.claimedAmount" },
                      { var: "data.scheduledAmount" },
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "VIC"] },
                  { "!=": [{ var: "data.dueDateForPayment" }, ""] },
                  { "<": [{ var: "data.dueDateForPayment" }, todayMinus10] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s17(3)(c) of the Act",
            inputMask: "",
            key: "dueDateForPayment_InValid_SA",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    ">": [
                      { var: "data.claimedAmount" },
                      { var: "data.scheduledAmount" },
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "SA"] },
                  { "!=": [{ var: "data.dueDateForPayment" }, ""] },
                  { "<": [{ var: "data.dueDateForPayment" }, todayMinus15] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s19(3)(b) of the Act",
            inputMask: "",
            key: "dueDateForPayment_InValid_ACT",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    ">": [
                      { var: "data.claimedAmount" },
                      { var: "data.scheduledAmount" },
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "ACT"] },
                  { "!=": [{ var: "data.dueDateForPayment" }, ""] },
                  { "<": [{ var: "data.dueDateForPayment" }, todayMinus10] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s21(3) of the Act",
            inputMask: "",
            key: "dueDateForPayment_InValid_TAS",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    ">": [
                      { var: "data.claimedAmount" },
                      { var: "data.scheduledAmount" },
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "TAS"] },
                  { "!=": [{ var: "data.dueDateForPayment" }, ""] },
                  { "<": [{ var: "data.dueDateForPayment" }, todayMinus10] },
                ],
              },
            },
          },
          // Add Indicate the amount the respondent intends to pay
          {
            label: "Indicate the amount the respondent intends to pay",
            mask: false,
            spellcheck: true,
            tableView: false,
            currency: "AUD",
            inputFormat: "plain",
            key: "amountRespondentIntendsToPay",
            type: "currency",
            input: true,
            delimiter: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.paymentScheduleIdentityRelaventClaim",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            label: "Indicate any amounts the respondent considers “excluded”",
            mask: false,
            spellcheck: true,
            tableView: false,
            currency: "AUD",
            inputFormat: "plain",
            key: "amountRespondentExcluded",
            type: "currency",
            input: true,
            delimiter: true,
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                and: [
                  { "==": [{ var: "data.applicantState" }, "VIC"] },
                  {
                    "===": [
                      { var: "data.paymentScheduleIdentityRelaventClaim" },
                      "yes",
                    ],
                  },
                ],
              },
            },
          },
          //blurb for payment schedule
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "If the Payment Schedule is less than the amount in the Payment Claim, then the Schedule must also include reasons why it is less and (if it is because payment is being withheld) reasons the respondent is withholding payment.",
            inputMask: "",
            key: "blurbForPaymentScheduleUpload",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.paymentScheduleIdentityRelaventClaim",
                  },
                  "yes",
                ],
              },
            },
          },
          //fileupload
          {
            type: "fileupload",
            label: "Upload files for payment schedule",
            disabled: false,
            placeholder: "Payment schedule documents",
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.relaventDetailsRegardingPaymentSchedule",
                  },
                  "yes",
                ],
              },
            },
          },
        ],
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },
      {
        title: "Notice of intention to adjudicate",
        collapsible: true,
        key: "panel",
        type: "panel",
        label: "Panel",
        input: false,
        tableView: false,
        components: [
          {
            type: "radio",
            label:
              "Details about the notice of intention to adjudicate can be found in relevant section of the Act. Did you provide a notice of intention to apply as per relevant section of the Act?",
            input: true,
            inline: true,
            tableView: false,
            key: "noticeOfIntentionToApply",
            persistent: true,
            values: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
            validate: {
              required: true,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.terms",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "radio",
            label:
              "Did the notice allow for 5 business days for respondent to provide payment schedule as per s17(2)(b) of the Act?",
            input: true,
            inline: true,
            tableView: false,
            key: "didYouNoticeAllowBusinessDays_NSW",
            persistent: true,
            values: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
            validate: {
              required: true,
            },
            conditional: {
              json: {
                and: [
                  { "===": [{ var: "data.terms" }, "yes"] },
                  { "==": [{ var: "data.applicantState" }, "NSW"] },
                ],
              },
            },
          },
          {
            type: "radio",
            label:
              "Did the notice allow for 5 business days for respondent to provide payment schedule as per 28(2)(b) of the Act?",
            input: true,
            inline: true,
            tableView: false,
            key: "didYouNoticeAllowBusinessDays_WA",
            persistent: true,
            values: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
            validate: {
              required: true,
            },
            conditional: {
              json: {
                and: [
                  { "===": [{ var: "data.terms" }, "yes"] },
                  { "==": [{ var: "data.applicantState" }, "WA"] },
                ],
              },
            },
          },

          {
            type: "radio",
            label:
              "Did the notice allow for 2 business days for respondent to provide payment schedule as per s18(2)(b) of the Act?",
            input: true,
            inline: true,
            tableView: false,
            key: "didYouNoticeAllowBusinessDays_VIC",
            persistent: true,
            values: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
            validate: {
              required: true,
            },
            conditional: {
              json: {
                and: [
                  { "===": [{ var: "data.terms" }, "yes"] },
                  { "==": [{ var: "data.applicantState" }, "VIC"] },
                ],
              },
            },
          },

          {
            type: "radio",
            label:
              "Did the notice allow for 5 business days for respondent to provide payment schedule as per s17(2)(b) of the Act?",
            input: true,
            inline: true,
            tableView: false,
            key: "didYouNoticeAllowBusinessDays_SA",
            persistent: true,
            values: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
            validate: {
              required: true,
            },
            conditional: {
              json: {
                and: [
                  { "===": [{ var: "data.terms" }, "yes"] },
                  { "==": [{ var: "data.applicantState" }, "SA"] },
                ],
              },
            },
          },

          {
            type: "radio",
            label:
              "Did the notice allow for 5 business days for respondent to provide payment schedule as per s19(2)(b) of the Act?",
            input: true,
            inline: true,
            tableView: false,
            key: "didYouNoticeAllowBusinessDays_ACT",
            persistent: true,
            values: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
            validate: {
              required: true,
            },
            conditional: {
              json: {
                and: [
                  { "===": [{ var: "data.terms" }, "yes"] },
                  { "==": [{ var: "data.applicantState" }, "ACT"] },
                ],
              },
            },
          },

          {
            type: "radio",
            label:
              "Did the notice allow for 5 business days for respondent to provide payment schedule as per s21(4)(a) of the Act?",
            input: true,
            inline: true,
            tableView: false,
            key: "didYouNoticeAllowBusinessDays_TAS",
            persistent: true,
            values: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
            validate: {
              required: true,
            },
            conditional: {
              json: {
                and: [
                  { "===": [{ var: "data.terms" }, "yes"] },
                  { "==": [{ var: "data.applicantState" }, "TAS"] },
                ],
              },
            },
          },
          // {
          //   "type": "radio",
          //   "label": "Did you provide a notice of intention to apply as per relevant section of the Act?",
          //   "input": true,
          //   "inline": true,
          //   "tableView": false,
          //   "key": "noticeOfIntentionToApply",
          //   "persistent": true,
          //     values: [
          //       {value: 'yes', label: 'Yes'},
          //       {value: 'no', label: 'No'}
          //     ],
          //     "validate": {
          //       "required": true
          //     },
          //     conditional: {
          //       "json": {
          //         "===": [
          //           {
          //             "var": "data.detailsAboutTheNoticeOfIntentionToAdjudicate"
          //           },
          //           "yes"
          //         ]
          //       }
          //     }
          // },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Please check under s17(2) to confirm you meet all criteria for a valid claim.",
            inputMask: "",
            key: "claimUnderLegislationText_detailsAboutTheNoticeOfIntentionToAdjudicate_NSW",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    "===": [
                      {
                        var: "data.detailsAboutTheNoticeOfIntentionToAdjudicateAndCopyOfNotice",
                      },
                      true,
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "NSW"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Please check under s18(2) to confirm you meet all criteria for a valid claim.",
            inputMask: "",
            key: "claimUnderLegislationText_detailsAboutTheNoticeOfIntentionToAdjudicate_VIC",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    "===": [
                      {
                        var: "data.detailsAboutTheNoticeOfIntentionToAdjudicateAndCopyOfNotice",
                      },
                      true,
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "VIC"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Please check under s17(2) to confirm you meet all criteria for a valid claim.",
            inputMask: "",
            key: "claimUnderLegislationText_detailsAboutTheNoticeOfIntentionToAdjudicate_SA",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    "===": [
                      {
                        var: "data.detailsAboutTheNoticeOfIntentionToAdjudicateAndCopyOfNotice",
                      },
                      true,
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "SA"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Please check under s19(2) to confirm you meet all criteria for a valid claim.",
            inputMask: "",
            key: "claimUnderLegislationText_detailsAboutTheNoticeOfIntentionToAdjudicate_ACT",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    "===": [
                      {
                        var: "data.detailsAboutTheNoticeOfIntentionToAdjudicateAndCopyOfNotice",
                      },
                      true,
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "ACT"] },
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content:
              "Please check under s21(4) to confirm you meet all criteria for a valid claim.",
            inputMask: "",
            key: "claimUnderLegislationText_detailsAboutTheNoticeOfIntentionToAdjudicate_TAS",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                and: [
                  {
                    "===": [
                      {
                        var: "data.detailsAboutTheNoticeOfIntentionToAdjudicateAndCopyOfNotice",
                      },
                      true,
                    ],
                  },
                  { "==": [{ var: "data.applicantState" }, "TAS"] },
                ],
              },
            },
          },
          {
            label: "Date served",
            format: "dd-MMM-yyyy",
            tableView: false,
            enableMinDateInput: false,
            datePicker: {
              disableWeekends: false,
              disableWeekdays: false,
            },
            enableMaxDateInput: false,
            enableTime: false,
            timePicker: {
              showMeridian: false,
            },
            key: "dateServed_72",
            type: "datetime",
            input: true,
            widget: {
              type: "calendar",
              displayInTimezone: "viewer",
              locale: "en",
              useLocaleSettings: false,
              allowInput: true,
              mode: "single",
              enableTime: false,
              noCalendar: false,
              format: "dd-MMM-yyyy",
              hourIncrement: 1,
              minuteIncrement: 1,
              time_24hr: true,
              minDate: null,
              disableWeekends: false,
              disableWeekdays: false,
              maxDate: null,
            },
            validate: {
              required: true,
              customPrivate: false,
            },
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.noticeOfIntentionToApply",
                  },
                  "yes",
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s17(3) of the Act",
            inputMask: "",
            key: "claimUnderLegislationText_detailsAboutTheNoticeOfIntentionToAdjudicate_NSW",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.didYouNoticeAllowBusinessDays_NSW_check",
                  },
                  true,
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s18(3) of the Act",
            inputMask: "",
            key: "claimUnderLegislationText_detailsAboutTheNoticeOfIntentionToAdjudicate_VIC",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.didYouNoticeAllowBusinessDays_VIC_check",
                  },
                  true,
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s17(3) of the Act",
            inputMask: "",
            key: "claimUnderLegislationText_detailsAboutTheNoticeOfIntentionToAdjudicate_SA",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.didYouNoticeAllowBusinessDays_SA_check",
                  },
                  true,
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s19(3) of the Act",
            inputMask: "",
            key: "claimUnderLegislationText_detailsAboutTheNoticeOfIntentionToAdjudicate_ACT",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.didYouNoticeAllowBusinessDays_ACT_check",
                  },
                  true,
                ],
              },
            },
          },
          {
            type: "htmlelement",
            input: false,
            tableView: true,
            content: "Your claim may be invalid under s21 of the Act",
            inputMask: "",
            key: "claimUnderLegislationText_detailsAboutTheNoticeOfIntentionToAdjudicate_TAS",
            prefix: "",
            suffix: "",
            multiple: false,
            protected: false,
            unique: false,
            persistent: true,
            customClass: "orangeText",
            conditional: {
              json: {
                "==": [
                  {
                    var: "data.didYouNoticeAllowBusinessDays_TAS_check",
                  },
                  true,
                ],
              },
            },
          },
          //upload
          {
            type: "fileupload",
            label: "Attach a copy of Notice",
            disabled: false,
            placeholder: "Notice",
            conditional: {
              json: {
                "===": [
                  {
                    var: "data.noticeOfIntentionToApply",
                  },
                  "yes",
                ],
              },
            },
          },
        ],
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },
      {
        type: "radio",
        label:
          "Declaration: I hereby declare that, The Information provided in this application is, to the best of my knowledge, accurate and truthful",
        input: true,
        inline: true,
        tableView: false,
        key: "userDeclarationText",
        persistent: true,
        values: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        validate: {
          required: true,
        },
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },
      {
        html: "<p>Any&nbsp;document&nbsp;that&nbsp;by&nbsp;or&nbsp;under&nbsp;this&nbsp;Act&nbsp;is&nbsp;authorised&nbsp;or&nbsp;required&nbsp;to&nbsp;be&nbsp;served&nbsp;on&nbsp;a&nbsp;person&nbsp;may&nbsp;be&nbsp;served&nbsp;on&nbsp;the&nbsp;person--</p><ul><li>by&nbsp;delivering&nbsp;it&nbsp;to&nbsp;the&nbsp;person&nbsp;personally,&nbsp;or</li><li>by&nbsp;lodging&nbsp;it&nbsp;during&nbsp;normal&nbsp;office&nbsp;hours&nbsp;at&nbsp;the&nbsp;person's&nbsp;ordinary&nbsp;place&nbsp;of&nbsp;business,&nbsp;or</li><li>by&nbsp;sending&nbsp;it&nbsp;by&nbsp;post&nbsp;addressed&nbsp;to&nbsp;the&nbsp;person's&nbsp;ordinary&nbsp;place&nbsp;of&nbsp;business,&nbsp;or</li><li>by&nbsp;email&nbsp;to&nbsp;an&nbsp;email&nbsp;address&nbsp;specified&nbsp;by&nbsp;the&nbsp;person&nbsp;for&nbsp;the&nbsp;service&nbsp;of&nbsp;documents&nbsp;of&nbsp;that&nbsp;kind,&nbsp;or</li><li>in&nbsp;the&nbsp;case&nbsp;of&nbsp;service&nbsp;by&nbsp;a&nbsp;party&nbsp;to&nbsp;a&nbsp;construction&nbsp;contract&nbsp;on&nbsp;another&nbsp;party&nbsp;to&nbsp;the&nbsp;construction&nbsp;contract--in&nbsp;the&nbsp;manner&nbsp;that&nbsp;may&nbsp;be&nbsp;provided&nbsp;under&nbsp;the&nbsp;construction&nbsp;contract.</li></ul>",
        label: "Content",
        refreshOnChange: false,
        key: "content1",
        type: "content",
        input: false,
        tableView: false,
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },
      // Add the section for each state
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "For further information, please consult <a target='_blank' href='http://classic.austlii.edu.au/au/legis/wa/num_act/baciopa20214o2021652/s31.html'>s31</a>",
        inputMask: "",
        key: "relaventStatuteNSW",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        conditional: {
          json: {
            "==": [
              {
                var: "data.applicantState",
              },
              "NSW",
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "For further information, please consult <a target='_blank' href='http://classic.austlii.edu.au/au/legis/wa/num_act/baciopa20214o2021652/s113.html'>s113</a>",
        inputMask: "",
        key: "relaventStatuteNSW",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        conditional: {
          json: {
            "==": [
              {
                var: "data.applicantState",
              },
              "WA",
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "For further information, please consult <a target='_blank' href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/vic/consol_act/bacisopa2002606/s50.html'>s50</a>",
        inputMask: "",
        key: "relaventStatuteVIC",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        conditional: {
          json: {
            "==": [
              {
                var: "data.applicantState",
              },
              "VIC",
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "For further information, please consult <a target='_blank' href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/sa/consol_act/bacisopa2009606/s34.html'>s34</a>",
        inputMask: "",
        key: "relaventStatuteSA",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        conditional: {
          json: {
            "==": [
              {
                var: "data.applicantState",
              },
              "SA",
            ],
          },
        },
      },
      {
        type: "htmlelement",
        input: false,
        tableView: true,
        content:
          "For further information, please consult <a target='_blank' href='http://www8.austlii.edu.au/cgi-bin/viewdoc/au/legis/tas/consol_act/bacisopa2009606/s40.html'>s40</a>",
        inputMask: "",
        key: "relaventStatuteTAS",
        prefix: "",
        suffix: "",
        multiple: false,
        protected: false,
        unique: false,
        persistent: true,
        conditional: {
          json: {
            "==": [
              {
                var: "data.applicantState",
              },
              "TAS",
            ],
          },
        },
      },
      {
        type: "radio",
        label: "Do you agree to the above content?",
        input: true,
        inline: true,
        tableView: false,
        key: "serviceDeclaration",
        persistent: true,
        values: [
          { value: "yes", label: "Yes" },
          { value: "no", label: "No" },
        ],
        validate: {
          required: true,
        },
        conditional: {
          json: {
            "===": [
              {
                var: "data.terms",
              },
              "yes",
            ],
          },
        },
      },
      {
        type: "button",
        label: "Submit",
        key: "submit",
        disableOnInvalid: false,
        input: true,
        tableView: false,
      },
    ];

    Formio.createForm(document.getElementById("formio"), {
      // this.formSpec = {
      //   "title": "My Test Form",
      components: formComponents,
    }).then(function (form) {
      formData = form;
      var guid = Guid.create().toJSON();
      if (jsonDataUrl != undefined) {
        httpClient
          .get<any>(
            that.baseUrl + "api/SampleData/GetJsonData?filepath=" + jsonDataUrl
          )
          .subscribe((data1) => {
            form.submission = {
              data: data1,
            };
          });
      } else {
        formData.submission = {
          data: {
            ...formData.submission.data,
            ...{ formId: formId },
            ...{ formName: "east-coast" },
            ...{
              prescribedAppointerName: "Resolution Institute",
              ...{ prescribedAppointerABN: "69008651232" },
              ...{
                prescribedAppointerPostalAddress1:
                  "Suite 602, Level 6, Tower B, Zenith Centre",
              },
              ...{
                prescribedAppointerPostalAddress2: "821-843 Pacific Highway",
              },
              ...{ prescribedAppointerState: "NSW" },
              ...{ prescribedAppointerSuburb: "Chatswood" },
              ...{ prescribedAppointerPostCode: "2067" },
              ...{ prescribedAppointerTelephoneNumber: "(02) 9251 3366" },
              ...{ prescribedAppointerFaxNumber: "(02) 9251 3733" },
              ...{
                prescribedAppointerEmail: "nominations@resolution.institute",
              },
            },
          },
        };
      }

      form.on("change", function (event: any) {
        if (
          event.changed &&
          formData.submission.data[event.changed.component.key] !== undefined
        ) {
          if (event.changed.component.key === "applicantABN") {
            formData.submission = {
              data: {
                ...formData.submission.data,
                ...{ displayabnValidationSuccess: false },
                ...{ displayabnValidationFailure: false },
              },
            };
          }
          if (
            event.changed.component.key === "dateOfClaim" ||
            event.changed.component.key ===
              "lastDateRelevantConstructionWorkCarriedOut"
          ) {
            if (
              formData.submission.data
                .lastDateRelevantConstructionWorkCarriedOut !== "" &&
              formData.submission.data.dateOfClaim !== ""
            ) {
              formData.submission = {
                data: {
                  ...formData.submission.data,
                  ...{ displayOnDateOfClaimCheckNSW: false },
                  ...{ displayOnDateOfClaimCheckSA: false },
                  ...{ displayOnDateOfClaimCheckACT: false },
                  ...{ displayOnDateOfClaimCheckTAS: false },
                },
              };
              if (
                formData.submission.data.dateOfClaim >=
                that
                  .moment(
                    formData.submission.data
                      .lastDateRelevantConstructionWorkCarriedOut
                  )
                  .add(12, "months")
                  .toISOString()
              ) {
                formData.submission = {
                  data: {
                    ...formData.submission.data,
                    ...{ displayOnDateOfClaimCheckNSW: true },
                    ...{ displayOnDateOfClaimCheckTAS: true },
                    ...{ displayOnDateOfClaimCheckACT: true },
                  },
                };
              }
              if (
                formData.submission.data.dateOfClaim >=
                that
                  .moment(
                    formData.submission.data
                      .lastDateRelevantConstructionWorkCarriedOut
                  )
                  .add(6, "months")
                  .toISOString()
              ) {
                formData.submission = {
                  data: {
                    ...formData.submission.data,
                    ...{ displayOnDateOfClaimCheckSA: true },
                  },
                };
              }
            }
            // formData.submission ={data: {...formData.submission.data, ...{displayabnValidationSuccess: false}, ...{displayabnValidationFailure: false}}}
          }
          if (
            event.changed.component.key === "referenceDate" &&
            formData.submission.data.referenceDate !== ""
          ) {
            formData.submission = {
              data: {
                ...formData.submission.data,
                ...{ checkReferenceDateValidation: false },
              },
            };
            if (
              that.moment().toISOString() >=
              that
                .moment(formData.submission.data.referenceDate)
                .add(3, "months")
                .toISOString()
            ) {
              formData.submission = {
                data: {
                  ...formData.submission.data,
                  ...{ checkReferenceDateValidation: true },
                },
              };
            }
          }
          if (
            (event.changed.component.key === "dateServed" ||
              event.changed.component.key === "dueDatForPayment" ||
              event.changed.component.key === "applicantState" ||
              event.changed.component.key ===
                "relaventDetailsRegardingPaymentSchedule") &&
            formData.submission.data.relaventDetailsRegardingPaymentSchedule ===
              "yes" &&
            formData.submission.data.dateServed !== "" &&
            formData.submission.data.dueDatForPayment !== "" &&
            formData.submission.data.applicantState !== ""
          ) {
            formData.submission = {
              data: {
                ...formData.submission.data,
                ...{ DateServedAndDateOfPaymentValidation_NSW: false },
                ...{ DateServedAndDateOfPaymentValidation_VIC: false },
                ...{ DateServedAndDateOfPaymentValidation_SA: false },
                ...{ DateServedAndDateOfPaymentValidation_TAS: false },
                ...{ DateServedAndDateOfPaymentValidation_ACT: false },
              },
            };
            if (
              formData.submission.data.applicantState === "NSW" &&
              that.moment(formData.submission.data.dateServed).toISOString() >
                moment1(formData.submission.data.dueDatForPayment)
                  .businessAdd(20)
                  ._d.toISOString()
            ) {
              formData.submission = {
                data: {
                  ...formData.submission.data,
                  ...{ DateServedAndDateOfPaymentValidation_NSW: true },
                },
              };
            }
            if (
              formData.submission.data.applicantState === "VIC" &&
              that.moment(formData.submission.data.dateServed).toISOString() >
                moment1(formData.submission.data.dueDatForPayment)
                  .businessAdd(10)
                  ._d.toISOString()
            ) {
              formData.submission = {
                data: {
                  ...formData.submission.data,
                  ...{ DateServedAndDateOfPaymentValidation_VIC: true },
                },
              };
            }
            if (
              formData.submission.data.applicantState === "SA" &&
              that.moment(formData.submission.data.dateServed).toISOString() >
                moment1(formData.submission.data.dueDatForPayment)
                  .businessAdd(20)
                  ._d.toISOString()
            ) {
              formData.submission = {
                data: {
                  ...formData.submission.data,
                  ...{ DateServedAndDateOfPaymentValidation_SA: true },
                },
              };
            }
            if (
              formData.submission.data.applicantState === "TAS" &&
              that.moment(formData.submission.data.dateServed).toISOString() >
                moment1(formData.submission.data.dueDatForPayment)
                  .businessAdd(20)
                  ._d.toISOString()
            ) {
              formData.submission = {
                data: {
                  ...formData.submission.data,
                  ...{ DateServedAndDateOfPaymentValidation_TAS: true },
                },
              };
            }
            if (
              formData.submission.data.applicantState === "ACT" &&
              that.moment(formData.submission.data.dateServed).toISOString() >
                moment1(formData.submission.data.dueDatForPayment)
                  .businessAdd(20)
                  ._d.toISOString()
            ) {
              formData.submission = {
                data: {
                  ...formData.submission.data,
                  ...{ DateServedAndDateOfPaymentValidation_ACT: true },
                },
              };
            }
          }

          if (
            (event.changed.component.key === "applicantState" ||
              event.changed.component.key === "dateServed_72") &&
            formData.submission.data.dateServed_72 !== "" &&
            formData.submission.data.applicantState !== ""
          ) {
            formData.submission = {
              data: {
                ...formData.submission.data,
                ...{ didYouNoticeAllowBusinessDays_NSW_check: false },
                ...{ didYouNoticeAllowBusinessDays_VIC_check: false },
                ...{ didYouNoticeAllowBusinessDays_SA_check: false },
                ...{ didYouNoticeAllowBusinessDays_ACT_check: false },
                ...{ didYouNoticeAllowBusinessDays_TAS_check: false },
                ...{ didYouNoticeAllowBusinessDays_WA_check: false },
              },
            };
            if (formData.submission.data.applicantState === "NSW") {
              if (
                that.moment().toISOString() >
                moment1(formData.submission.data.dateServed_72)
                  .businessAdd(15)
                  ._d.toISOString()
              ) {
                // if (that.moment().toISOString() > moment1(formData.submission.data.dueDateForPaymentSchedule).businessAdd(20)._d.toISOString()) {
                formData.submission = {
                  data: {
                    ...formData.submission.data,
                    ...{ didYouNoticeAllowBusinessDays_NSW_check: true },
                  },
                };
                // }
              }
            }
            if (formData.submission.data.applicantState === "VIC") {
              if (
                that.moment().toISOString() >
                moment1(formData.submission.data.dateServed_72)
                  .businessAdd(7)
                  ._d.toISOString()
              ) {
                // if (that.moment().toISOString() > moment1(formData.submission.data.dueDateForPaymentSchedule).businessAdd(10)._d.toISOString()) {
                formData.submission = {
                  data: {
                    ...formData.submission.data,
                    ...{ didYouNoticeAllowBusinessDays_VIC_check: true },
                  },
                };
                // }
              }
            }
            if (formData.submission.data.applicantState === "SA") {
              if (
                that.moment().toISOString() >
                moment1(formData.submission.data.dateServed_72)
                  .businessAdd(20)
                  ._d.toISOString()
              ) {
                // if (that.moment().toISOString() > moment1(formData.submission.data.dueDateForPaymentSchedule).businessAdd(20)._d.toISOString()) {
                formData.submission = {
                  data: {
                    ...formData.submission.data,
                    ...{ didYouNoticeAllowBusinessDays_SA_check: true },
                  },
                };
                // }
              }
            }
            if (formData.submission.data.applicantState === "ACT") {
              if (
                that.moment().toISOString() >
                moment1(formData.submission.data.dateServed_72)
                  .businessAdd(15)
                  ._d.toISOString()
              ) {
                // if (that.moment().toISOString() > moment1(formData.submission.data.dueDateForPaymentSchedule).businessAdd(10)._d.toISOString()) {
                formData.submission = {
                  data: {
                    ...formData.submission.data,
                    ...{ didYouNoticeAllowBusinessDays_ACT_check: true },
                  },
                };
                // }
              }
            }
            if (formData.submission.data.applicantState === "TAS") {
              if (
                that.moment().toISOString() >
                moment1(formData.submission.data.dateServed_72)
                  .businessAdd(15)
                  ._d.toISOString()
              ) {
                // if (that.moment().toISOString() > moment1(formData.submission.data.dueDateForPaymentSchedule).businessAdd(20)._d.toISOString()) {
                formData.submission = {
                  data: {
                    ...formData.submission.data,
                    ...{ didYouNoticeAllowBusinessDays_TAS_check: true },
                  },
                };
                // }
              }
            }
            if (formData.submission.data.applicantState === "WA") {
              if (
                that.moment().toISOString() >
                moment1(formData.submission.data.dateServed_72)
                  .businessAdd(15)
                  ._d.toISOString()
              ) {
                formData.submission = {
                  data: {
                    ...formData.submission.data,
                    ...{ didYouNoticeAllowBusinessDays_WA_check: true },
                  },
                };
              }
            }
          }
          if (event.changed.component.key === "noticeOfIntentionToApply") {
            // if (formData.submission.data.detailsAboutTheNoticeOfIntentionToAdjudicate === 'no' && formData.submission.data.noticeOfIntentionToApply === 'no') {
            //   formData.submission = {data: {...formData.submission.data, ...{detailsAboutTheNoticeOfIntentionToAdjudicateAndCopyOfNotice: false}}}
            // }
            formData.submission = {
              data: {
                ...formData.submission.data,
                ...{
                  detailsAboutTheNoticeOfIntentionToAdjudicateAndCopyOfNotice:
                    false,
                },
              },
            };

            if (
              formData.submission.data.noticeOfIntentionToApply !== "" &&
              formData.submission.data.noticeOfIntentionToApply !== "yes"
            ) {
              formData.submission = {
                data: {
                  ...formData.submission.data,
                  ...{
                    detailsAboutTheNoticeOfIntentionToAdjudicateAndCopyOfNotice:
                      true,
                  },
                  ...{ didYouNoticeAllowBusinessDays_NSW_check: false },
                  ...{ didYouNoticeAllowBusinessDays_VIC_check: false },
                  ...{ didYouNoticeAllowBusinessDays_SA_check: false },
                  ...{ didYouNoticeAllowBusinessDays_ACT_check: false },
                  ...{ didYouNoticeAllowBusinessDays_TAS_check: false },
                  ...{ didYouNoticeAllowBusinessDays_WA_check: false },
                },
              };
            }
            // } else {
            //   formData.submission = {data: {...formData.submission.data, ...{detailsAboutTheNoticeOfIntentionToAdjudicateAndCopyOfNotice: false}}}
            // }
          }
        }
      });

      form.on("submit", function (form: any) {
        var serviceResponse = that.appService.getUrls();
        console.log("serviceResponse", serviceResponse);
        var pdfUrl = "/documents/" + formId + ".pdf";
        var pdfData = {
          key: AppService.generatedPdfKey,
          url: [],
        };
        pdfData.url.push(pdfUrl);
        serviceResponse.push(pdfData);
        // var divToSave = document.getElementById('formio').outerHTML;
        // divToSave = "<html><head><link rel='stylesheet' href='sample.css'></head><body>" + divToSave + "</body></html>"
        // var abc = JSON.stringify(divToSave);
        // var abc = {
        //   "sometext": divToSave
        // }
        let today = new Date();
        form.data.submission_date = today.toString();
        form.data.files_submitted = that.appService.getUploadedFilesString();
        var jsonToServer = { ...form.data, ...{ files: serviceResponse } };

        let jsonToServer_ = JSON.parse(JSON.stringify(jsonToServer));

        today.setHours(0, 0, 0, 0);
        let newComponent = {
          type: "textfield",
          input: true,
          tableView: true,
          inputType: "text",
          inputMask: "",
          label: "Date Submitted",
          key: "submission_date",
          placeholder: "",
          prefix: "",
          suffix: "",
          multiple: false,
          protected: false,
          unique: false,
          persistent: true,
          conditional: {
            json: {
              "===": [
                {
                  var: "data.submission_date",
                },
                "yes",
              ],
            },
          },
        };

        let filesComponent = {
          type: "textfield",
          input: true,
          tableView: true,
          inputType: "text",
          inputMask: "",
          label: "Files Submitted",
          key: "files_submitted",
          placeholder: "",
          prefix: "",
          suffix: "",
          multiple: false,
          defaultValue: "Test_Default",
          protected: false,
          unique: false,
          persistent: true,
          conditional: {
            json: {
              "===": [
                {
                  var: "data.files_submitted",
                },
                "yes",
              ],
            },
          },
        };

        let panel = {
          title: "Form details",
          key: "panel",
          type: "panel",
          components: [newComponent, filesComponent],
        };

        formComponents.unshift(<any>panel);
        let component = {
          type: "form",
          title: "Resolution Institute Quickfiles application",
          display: "form",
          components: formComponents,
        };

        let submission = {
          //owner: jsonToServer_.formName,
          //_id: formId,
          //modified: today.toString(),
          data: jsonToServer,
        };

        let options = {
          ignoreLayout: false,
        };

        let exporter = new FormioExport(component, submission, options);

        let config = {
          download: false,
          filename: formId + ".pdf",
        };

        /*
      exporter.toPdf(config).then((pdf) => {
        // download the pdf file
        pdf.save(config.filename);
      });
      */

        exporter
          .toPdf(config)
          .then((pdf) => {
            return pdf.output("datauristring");
          })
          .then((datauri_base64) => {
            if (datauri_base64) {
              // console.log(datauri_base64);

              var pdfObject = {};
              pdfObject["base64file"] = datauri_base64;
              pdfObject["filename"] = config.filename;

              that.httpClient
                .post<any>(that.baseUrl + "api/SampleData/SaveToPdf", pdfObject)
                .subscribe(
                  (result) => {
                    if (result) {
                      console.log("PDF uploaded!!");

                      that.httpClient
                        .post<any>(
                          that.baseUrl + "api/SampleData/PostFormData",
                          jsonToServer
                        )
                        .subscribe(
                          (result) => {
                            if (result) {
                              console.log("Form data uploaded!!");

                              that.router.navigateByUrl("/east-coast-thankyou");
                            } else {
                              alert(
                                "There was an error with the submision, please try again. -1"
                              );

                              return false;
                            }
                          },
                          (error) => {
                            console.error(error);

                            return false;
                          }
                        );
                    } else {
                      alert(
                        "There was an error with the submision, please try again. -2"
                      );

                      return false;
                    }
                  },
                  (error) => {
                    console.error(error);

                    return false;
                  }
                );
            }
          })
          .catch(function (error) {
            alert(
              "There was an error with the submision, please try again. -3"
            );

            return false;
          });
      });
    });
    // this.formData = {
    // data: {
    // "firstName": "Laksh",
    // "lastName": "Mikkili"
    // }
    // };
    // attaching the function to window to access the function in json
    // var form = this.form;
    (window as any).onCheck = function onCheck(abnVal: any) {
      that.ngxLoader.start();
      formData.submission = {
        data: {
          ...formData.submission.data,
          ...{ displayabnValidationSuccess: false },
          ...{ displayabnValidationFailure: false },
        },
      };
      // console.log("abnVal is" + abnVal);
      // console.log("form is", formData);
      httpClient
        .get<any>(baseUrl + "api/SampleData/FindABN?searchText=" + abnVal)
        .subscribe((result: any) => {
          if (result.ABRPayloadSearchResults.response.businessEntity) {
            formData.submission = {
              data: {
                ...formData.submission.data,
                ...{ displayabnValidationSuccess: true },
                ...{ displayabnValidationFailure: false },
              },
            };
          } else {
            formData.submission = {
              data: {
                ...formData.submission.data,
                ...{ displayabnValidationSuccess: false },
                ...{ displayabnValidationFailure: true },
              },
            };
          }
          that.ngxLoader.stop();
        });
    };

    (window as any).onCheck1 = function onCheck1(abnVal: any) {
      that.ngxLoader.start();
      formData.submission = {
        data: {
          ...formData.submission.data,
          ...{ displayabnValidationSuccessRespondent: false },
          ...{ displayabnValidationFailureRespondent: false },
        },
      };
      // console.log("abnVal is" + abnVal);
      // console.log("form is", formData);
      httpClient
        .get<any>(baseUrl + "api/SampleData/FindABN?searchText=" + abnVal)
        .subscribe((result: any) => {
          if (result.ABRPayloadSearchResults.response.businessEntity) {
            formData.submission = {
              data: {
                ...formData.submission.data,
                ...{ displayabnValidationSuccessRespondent: true },
                ...{ displayabnValidationFailureRespondent: false },
              },
            };
          } else {
            formData.submission = {
              data: {
                ...formData.submission.data,
                ...{ displayabnValidationSuccessRespondent: false },
                ...{ displayabnValidationFailureRespondent: true },
              },
            };
          }
          that.ngxLoader.stop();
        });
    };

    (window as any).checkValid = function checkValid(value: any) {
      return value != null || value != "";
    };
  }

  onChange($event: any) {
    console.log("onChange", $event);
  }

  onSubmit(form: any) {
    var serviceResponse = this.appService.getUrls();

    var jsonToServer = { ...form.data, ...{ files: serviceResponse } };
    console.log(jsonToServer);
    this.httpClient
      .post<any>(this.baseUrl + "api/SampleData/PostFormData", jsonToServer)
      .subscribe(
        (result) => {
          if (result) {
            console.log("the form data is submitted to queue");
            this.router.navigateByUrl("/east-coast-thankyou");
          } else {
            console.log("form is not saved");
          }
        },
        (error) => {
          console.error(error);
          // display a message that the form is not saved
        }
      );
  }

  // onClick11($event) {
  //   var serviceResponse = this.appService.getUrls();
  //   console.log('serviceResponse', serviceResponse);
  //   // var divToSave = document.getElementById('formio').outerHTML;
  //   // divToSave = "<html><head><link rel='stylesheet' href='sample.css'></head><body>" + divToSave + "</body></html>"
  //   // var abc = JSON.stringify(divToSave);
  //   var abc = {
  //     "sometext": "abc"
  //   }
  //   setTimeout(() => {
  //     window.status = "completed";
  //   }, 10000);

  //   // var jsonToServer = {...form.data, ...{files: serviceResponse}};
  //   // console.log(jsonToServer);
  //   // that.httpClient.post<any>(that.baseUrl + 'api/SampleData/PostFormData', jsonToServer).subscribe(result => {
  //     // if (result) {
  //       this.httpClient.post<any>(this.baseUrl + 'api/SampleData/SaveJsonToPdf', abc).subscribe(response => {
  //         console.log("Saved the form to pdf");
  //       })
  //       console.log('the form data is submitted to queue')
  // that.router.navigateByUrl('/thankyou');
  // } // else {
  // console.log('form is not saved');
  // }
  // }, error => {
  // console.error(error)
  // display a message that the form is not saved
  // });
  // }
}
